import React from "react";

export const renderError = (message) => <div style={{display: 'block'}} className="invalid-feedback">{message}</div>;